/**
 * DeliveryBook Constants V3
 * Events and endpoints for deliverybook feature
 */

export const DELIVERYBOOK_STATUS = {
  SAVED: 'saved',
  INVITED: 'invited',
  REQUESTED: 'requested'
};

export const DELIVERYBOOK_TABS = {
  SAVED: 'saved',
  INVITATIONS: 'invitations',
  REQUESTS: 'requests'
};

export const DELIVERYBOOK_POLLING_CONFIG = {
  MAX_ATTEMPTS: 30,
  INTERVAL_MS: 2000,
  BACKOFF_MULTIPLIER: 1.2,
  MAX_INTERVAL_MS: 5000
};

// Merge with existing constants
export default {
  EVENTS: {
    DELIVERYBOOK: {
      // Addresses
      ADDRESSES_LOAD: 'deliverybook.addresses.load',
      ADDRESSES_LOADING: 'deliverybook.addresses.loading',
      ADDRESSES_LOADED: 'deliverybook.addresses.loaded',
      ADDRESSES_LOAD_ERROR: 'deliverybook.addresses.load_error',

      // Add address
      ADDRESS_CREATE: 'deliverybook.address.create',
      ADDRESS_CREATING: 'deliverybook.address.creating',
      ADDRESS_CREATED: 'deliverybook.address.created',
      ADDRESS_CREATE_ERROR: 'deliverybook.address.create_error',

      // Update address
      ADDRESS_UPDATE: 'deliverybook.address.update',
      ADDRESS_UPDATING: 'deliverybook.address.updating',
      ADDRESS_UPDATED: 'deliverybook.address.updated',
      ADDRESS_UPDATE_ERROR: 'deliverybook.address.update_error',

      // Delete address
      ADDRESS_DELETE: 'deliverybook.address.delete',
      ADDRESS_DELETING: 'deliverybook.address.deleting',
      ADDRESS_DELETED: 'deliverybook.address.deleted',
      ADDRESS_DELETE_ERROR: 'deliverybook.address.delete_error',

      // Request address
      ADDRESS_REQUEST_CREATE: 'deliverybook.address_request.create',
      ADDRESS_REQUEST_CREATING: 'deliverybook.address_request.creating',
      ADDRESS_REQUEST_CREATED: 'deliverybook.address_request.created',
      ADDRESS_REQUEST_CREATE_ERROR: 'deliverybook.address_request.create_error',

      // Invite contact
      ADDRESS_INVITE_CREATE: 'deliverybook.address_invite.create',
      ADDRESS_INVITE_CREATING: 'deliverybook.address_invite.creating',
      ADDRESS_INVITE_CREATED: 'deliverybook.address_invite.created',
      ADDRESS_INVITE_CREATE_ERROR: 'deliverybook.address_invite.create_error',

      // Delete invite
      ADDRESS_INVITE_DELETE: 'deliverybook.address_invite.delete',
      ADDRESS_INVITE_DELETING: 'deliverybook.address_invite.deleting',
      ADDRESS_INVITE_DELETED: 'deliverybook.address_invite.deleted',
      ADDRESS_INVITE_DELETE_ERROR: 'deliverybook.address_invite.delete_error',

      // Set Default
      ADDRESS_SET_DEFAULT: 'deliverybook.address.set_default',
      ADDRESS_SETTING_DEFAULT: 'deliverybook.address.setting_default',
      ADDRESS_DEFAULT_SET: 'deliverybook.address.default_set',
      ADDRESS_SET_DEFAULT_ERROR: 'deliverybook.address.set_default_error',

      // Selection (for cart)
      ADDRESS_SELECT: 'deliverybook.address.select',
      ADDRESS_SELECTED: 'deliverybook.address.selected',
      ADDRESS_SELECTION_CANCELLED: 'deliverybook.address.selection_cancelled',

      // Modal
      MODAL_OPEN: 'deliverybook.modal.open',
      MODAL_CLOSE: 'deliverybook.modal.close',
      REQUEST_MODAL_OPEN: 'deliverybook.request_modal.open',
      ADD_MODAL_OPEN: 'deliverybook.add_modal.open',

      // Tab change
      TAB_CHANGE: 'deliverybook.tab.change',
      TAB_CHANGED: 'deliverybook.tab.changed',

      // Loading state
      LOADING: {
        START: 'deliverybook.loading.start',
        FINISH: 'deliverybook.loading.finish'
      },

      // Copy link (for invitations and requests)
      LINK_COPY: 'deliverybook.link.copy',

      // Legacy V2 events (for compatibility)
      NEW_DELIVERY_LOCATION_ADDED: 'new_delivery_location_added',
      DELIVERY_LOCATION_LIST_CHANGED: 'delivery_location_list_changed',
      LOCATION_CONFIRMED: 'locationConfirmed'
    }
  },

  ENDPOINTS: {
    DELIVERYBOOK: {
      BASE: 'https://api.monrapidoo.com',

      // Addresses (Location API)
      ADDRESSES_GET: '/location/addresses?group=ultraxeno',
      ADDRESS_CREATE: '/location/add/address?group=ultraxeno',
      ADDRESS_UPDATE: '/location/update/address', // Id added dynamically
      ADDRESS_DELETE: '/location/delete/address', // Id added dynamically
      ADDRESS_SET_DEFAULT: '/location/addresses/default?group=ultraxeno',

      // Location Requests (Location API)
      ADDRESS_REQUEST_CREATE: '/location/request?group=ultraxeno',
      ADDRESS_REQUESTS_GET: '/location/requests?group=ultraxeno',
      ADDRESS_REQUEST_DELETE: '/location/delete/request', // Id added dynamically

      // Invitations (Affiliation API)
      ADDRESS_INVITE_CREATE: '/affiliation/invite?group=ultraxeno',
      ADDRESS_INVITATIONS_GET: '/affiliation/invitations?group=ultraxeno',
      ADDRESS_INVITE_DELETE: '/affiliation/delete/invitation' // Id added dynamically
    },

    // Aliases for compatibility within the feature
    deliveryLocations: 'deliveryLocations',
    addDeliveryLocation: 'addDeliveryLocation',
    removeDeliveryLocation: 'removeDeliveryLocation',
    updateDeliveryLocation: 'updateDeliveryLocation',
    inviteContact: 'inviteContact',
    requestLocationInfo: 'requestLocationInfo',
    userInvitations: 'userInvitations',
    locationRequests: 'locationRequests'
  }
};
